import qs from 'qs';

const decodeSearchRouteText = (searchText?: string): string => {
  if (!searchText) {
    return '';
  }

  try {
    return decodeURIComponent(searchText);
  } catch (_error) {
    return searchText;
  }
};

const encodeSearchRouteText = (searchText?: string): string => {
  if (!searchText) {
    return '';
  }

  return encodeURIComponent(searchText);
};

const buildSearchRoute = (searchText: string): string => {
  // History v4 decodes pathnames before writing them, leaving literal percent signs in the browser URL.
  if (searchText.includes('%')) {
    return `/search/results?${qs.stringify({ searchText })}`;
  }

  return `/search/${encodeSearchRouteText(searchText)}`;
};

const getSearchRouteText = (searchText?: string, search = ''): string => {
  const params = qs.parse(search, { ignoreQueryPrefix: true });
  if (searchText === 'results' && typeof params.searchText === 'string') {
    return params.searchText;
  }

  return decodeSearchRouteText(searchText);
};

export {
  buildSearchRoute,
  getSearchRouteText,
  decodeSearchRouteText,
  encodeSearchRouteText,
};
